import React from 'react';
import {
  EyeIcon,
  PencilIcon,
  EnvelopeIcon,
  ArrowPathIcon,
  DocumentArrowUpIcon,
  ClipboardDocumentCheckIcon,
  CurrencyDollarIcon,
  TrashIcon
} from '@heroicons/react/24/outline';

const BulkActions = ({ 
  selectedCount, 
  onClearSelection, 
  onViewDetails, 
  onEdit, 
  onSendEmail, 
  onViewHistory, 
  onDocumentUpload, 
  onVerification, 
  onCreateInvoice,
  onDelete,
  hasUpdatePermission,
  hasDeletePermission 
}) => {
  if (selectedCount === 0) return null;

  return (
    <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-6">
      <div className="flex items-center justify-between">
        <div className="flex items-center space-x-4">
          <span className="text-sm font-medium text-blue-900">
            {selectedCount} submission{selectedCount !== 1 ? 's' : ''} selected
          </span>
          <button
            onClick={onClearSelection}
            className="text-sm text-blue-600 hover:text-blue-800 underline"
          >
            Clear selection
          </button>
        </div>
        <div className="flex items-center space-x-2">
          <button
            onClick={onViewDetails}
            className="inline-flex items-center px-3 py-1.5 text-sm font-medium rounded text-blue-700 bg-blue-100 hover:bg-blue-200"
            title="View Details"
          >
            <EyeIcon className="h-4 w-4 mr-1" />
            View Details
          </button>
          {hasUpdatePermission && (
            <button
              onClick={onEdit}
              className="inline-flex items-center px-3 py-1.5 text-sm font-medium rounded text-green-700 bg-green-100 hover:bg-green-200"
              title="Edit Submission"
            >
              <PencilIcon className="h-4 w-4 mr-1" />
              Edit
            </button>
          )}
          <button
            onClick={onSendEmail}
            className="inline-flex items-center px-3 py-1.5 text-sm font-medium rounded text-purple-700 bg-purple-100 hover:bg-purple-200"
            title="Send Email"
          >
            <EnvelopeIcon className="h-4 w-4 mr-1" />
            Send Email
          </button>
          <button
            onClick={onViewHistory}
            className="inline-flex items-center px-3 py-1.5 text-sm font-medium rounded text-gray-700 bg-gray-100 hover:bg-gray-200"
            title="View History"
          >
            <ArrowPathIcon className="h-4 w-4 mr-1" />
            History
          </button>
          <button
            onClick={onDocumentUpload}
            className="inline-flex items-center px-3 py-1.5 text-sm font-medium rounded text-blue-700 bg-blue-100 hover:bg-blue-200"
            title="Upload Documents"
          >
            <DocumentArrowUpIcon className="h-4 w-4 mr-1" />
            Documents
          </button>
          <button
            onClick={onVerification}
            className="inline-flex items-center px-3 py-1.5 text-sm font-medium rounded text-green-700 bg-green-100 hover:bg-green-200"
            title="Verification"
          >
            <ClipboardDocumentCheckIcon className="h-4 w-4 mr-1" />
            Verify
          </button>
          <button
            onClick={onCreateInvoice}
            className="inline-flex items-center px-3 py-1.5 text-sm font-medium rounded text-green-700 bg-green-100 hover:bg-green-200"
            title="Create Invoice"
          >
            <CurrencyDollarIcon className="h-4 w-4 mr-1" />
            Invoice
          </button>
          {hasDeletePermission && (
            <button
              onClick={onDelete}
              className="inline-flex items-center px-3 py-1.5 text-sm font-medium rounded text-red-700 bg-red-100 hover:bg-red-200"
              title="Delete Selected"
            >
              <TrashIcon className="h-4 w-4 mr-1" />
              Delete
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default BulkActions; 